import React, { useState } from 'react';
import { BellRing, Loader2, Send } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { Input } from './ui/input';
import { Switch } from './ui/switch';

export function SyncAlertsCard({ cfg, setField }) {
  const { sendTestSyncAlert } = useAuth();
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const test = async () => {
    setBusy(true); setMsg(null);
    try { const r = await sendTestSyncAlert(); setMsg({ ok: true, text: `Test alert sent to ${r.recipients.join(', ')}` }); }
    catch (e) { setMsg({ ok: false, text: e?.response?.data?.detail || 'Could not send the test alert' }); }
    setBusy(false);
  };

  return (
    <div className="bg-white rounded-lg p-5 border shadow-sm" style={{ borderColor: 'rgba(0,0,0,0.08)' }} data-testid="sync-alerts-card">
      <div className="flex items-center gap-2 mb-3"><BellRing size={16} style={{ color: 'var(--navy)' }} /><h3 className="font-title text-lg" style={{ color: 'var(--navy)' }}>Sync alerts</h3></div>
      <div className="flex items-center gap-3">
        <Switch data-testid="alerts-enabled-toggle" checked={cfg.sync_alerts_enabled !== false} onCheckedChange={(v) => setField('sync_alerts_enabled', v)} />
        <span className="text-sm">Email admins and the Secretary when a nightly sync adds new members, hits conflicts, or fails</span>
      </div>
      <div className="grid md:grid-cols-2 gap-2 mt-3 items-end">
        <div>
          <label className="text-xs" style={{ color: 'var(--olive)' }}>Extra recipients (comma-separated)</label>
          <Input data-testid="alerts-extra-emails" value={cfg.sync_alert_emails || ''} onChange={(e) => setField('sync_alert_emails', e.target.value)} placeholder="secretary@yourdomain.org.au, treasurer@…" />
        </div>
        <div className="flex items-center gap-2">
          <button data-testid="alerts-send-test" onClick={test} disabled={busy} className="inline-flex items-center gap-2 px-3 py-2 rounded text-sm font-title" style={{ background: 'var(--sage)', color: 'var(--ink)', opacity: busy ? 0.6 : 1 }}>
            {busy ? <Loader2 className="animate-spin" size={14} /> : <Send size={14} />} Send test alert
          </button>
        </div>
      </div>
      <p className="text-xs mt-2" style={{ color: 'var(--olive)' }}>Always goes to every System Administrator plus the organisation contact email (Secretary) set in Admin → Organisation. Uses the Email settings provider — save settings first.</p>
      {msg && <p className="text-sm mt-2" data-testid="alerts-test-result" style={{ color: msg.ok ? '#1a7f37' : '#8a1f11' }}>{msg.text}</p>}
    </div>
  );
}
